// extracted by mini-css-extract-plugin
export default {"dashboard":"dashboard_dashboard__1SrdO","registertitle":"dashboard_registertitle__PpE1W","tabs":"dashboard_tabs__BvuLI","tabList":"dashboard_tabList__iGkW0"};